import PluginContainer from "./PluginContainer";
import Sdk from "../Sdk";
import PluginInterface from "./PluginInterface";

export default class PluginsManager {

    private pluginContainers: PluginContainer[] = [];
    sdk: Sdk;

    constructor(sdk: Sdk) {
        this.sdk = sdk;
    }
    
    addPlugin(plugin: any): PluginContainer {
        let pluginContainer: PluginContainer = new PluginContainer(plugin, this.sdk);
        this.pluginContainers.push(pluginContainer);
        return pluginContainer;
    }
    
    destroyPlugins(): void {
        for(var i in this.pluginContainers) {
            this.pluginContainers[i].plugin.destroy();
        }
        this.pluginContainers = [];
    }


}